import React, { useState, useEffect, Fragment } from 'react';
import './SingleSelection.scss';
import Button from '../../../../partials/Button';
import {SimpleModal} from '../../../../partials/Modal'
import FeedbackBlock from '../../../../partials/FeedbackBlock'
import Scroll from '../../../../partials/Scroll/Scroll';
import Icons from '../../../../partials/Icons';

const SingleSelection = (props) => {

  const { data, onComplete } = props;

  const options = props.options || {};

  const [ order, setOrder ] = useState([]);
  const [optionSelected, setOptionSelected] = useState();
  const [errors, SetErrors] = useState(false);

  const resetStep = () => {
    setOptionSelected();
    SetErrors(false);
    randomizeOptions();
  }

  const passValidation = () => {
    if(!data.options[optionSelected].correct && !errors) {
      SetErrors(true);
    }
    return errors;
  }

  const randomizeOptions = () => {
    let newOrder = [];
    if(options.hasOwnProperty("randomizeOptions")) {
      if(options.randomizeOptions) {
       newOrder = data.options.sort( (a, b) => 0.5 - Math.random() );
      }
    } else {
      newOrder = data.options;
    }
    setOrder(newOrder);
  };

  const handleFeedback = () => {
    if( optionSelected !== null && optionSelected !== undefined ) {

      if(errors) {
        resetStep()
      }
      else{
        onComplete(false)
      }

    }
  }

  useEffect(() => {
    resetStep()
  }, [data])

  useEffect(() => {
    if(optionSelected!== null && optionSelected !== undefined) {
      console.log('Validation block')
      passValidation();
    }
  }, [optionSelected]);


  const handleSelection = (selectedIndex) =>{
      if(!optionSelected!==selectedIndex) {
        setOptionSelected(selectedIndex);
      }
  }

  return <div className="single-selection">
    <div className="label">
      <h2>{data.questionText}</h2>
    </div>
    <div className="options-container">
    <Scroll>
        <div className="options">
        {
          order.map( (option, optionIndex) => (
            <div key={`option-${optionIndex}`} className="option-icon">
            <div
              className={`option ${optionSelected===optionIndex ? 'selected' : 'not-selected'}`} 
              onClick={() => handleSelection(optionIndex) }>
                {option.text} 
                
            </div>
              <span>
                { optionSelected===optionIndex &&
                  <>
                    { !option.correct ? <Icons name="incorrect" />  :  <Icons name="check" /> }
                  </>
                }</span>
            </div>
          ))
        }
      </div>
    </Scroll>
    <div className="notes">
      {
        order.map( (option, optionIndex) => (
          <Fragment key={`note-${optionIndex}`}>
            <div className={`notes ${optionSelected===optionIndex ? 'selected' : 'not-selected'}`} dangerouslySetInnerHTML={{ __html:option.notes }}></div>
          </Fragment>
        ))
      }
    </div>


      { optionSelected !== null && optionSelected !== undefined &&
        <SimpleModal size="small" scroll={false} show={true} className='simple-modal'>
          <FeedbackBlock variant="fill" status={!errors ? 'success':'failed'} caption={!errors ? 'Correct':'Incorrect'}>
            <Scroll>
              <div className='feedback-text' dangerouslySetInnerHTML={{ __html:order[optionSelected].feedback }}></div>
            </Scroll>
            { !errors &&
                <Button text="Next" onClick={ handleFeedback } /> 
            }
            { errors &&
                <Button text="Retry" onClick={ handleFeedback } /> 
            }  
          </FeedbackBlock>

        </SimpleModal>
      } 
    </div>
  </div>
}

export default SingleSelection;